import React from 'react';

const PrivacyPolicy = () => {
    return (
        <div>
           <h1>PrivacyPolicy</h1>
           <ng-marketing-component content-code="FOWWIIV-PRIVACY"></ng-marketing-component>
        </div>
    );
}
export default PrivacyPolicy; 